import http from '../http'

const api = {
    // 获取导航
    getBanners(params) {
        return http.get('/wp-json/dt_api/page_info', {
            params,
        })
    }
}

const state = {
    banners: [],
    newestSeries: {
        new_categories: []
    },
    stories: {
        new_stories: []
    },
}

const mutations = {
    GET_BANNERS: state => {
        return state
    },
    SET_BANNERS: (state, {banners}) => {
        state.banners = banners
    },
    SET_SERIES: (state, {newestSeries}) => {
        state.newestSeries = newestSeries
    },
    SET_STORIES: (state, {stories}) => {
        state.stories = stories
    },
}

// 所有的mutations转换成actions进行调用
const actions = {
    async getBanners({commit}) {
        commit('GET_BANNERS')
        const lang = window.localStorage.getItem('lang')

        await api.getBanners({
            slug: 'index',
            lang,
        }).then(res => {
            if (res.data.data) {
                commit('SET_BANNERS', {
                    banners: res.data.data.banner_pictures,
                    newestSeries: res.data.data.new_categories,
                    stories: res.data.data.new_stories,
                })

                commit('SET_SERIES', {
                    banners: res.data.data.banner_pictures,
                    newestSeries: res.data.data.new_categories,
                    stories: res.data.data.new_stories,
                })

                commit('SET_STORIES', {
                    banners: res.data.data.banner_pictures,
                    newestSeries: res.data.data.new_categories,
                    stories: res.data.data.new_stories,
                })

                commit('common/SET_PAGE_THEME',  {
                    theme: res.data.data.theme
                }, {root: true})
                commit('common/SET_THEME',  {
                    theme: res.data.data.theme,
                    wxShare: res.data.data.wechat_share,
                }, {root: true})
            }
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
